var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.number)?_c('div',{staticClass:"y-split-number"},_vm._l((_vm.splitNumbersToDigit(_vm.number)),function(i,index){return _c('span',{key:index,class:_vm.wrapperClass},[_vm._v(" "+_vm._s(_vm._f("digits")(i))+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }